import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function ImpactStats() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api
      .get("/impact/stats")
      .then((r) => setStats(r.data))
      .catch(() => {});
  }, []);

  const community = stats?.community_stats || [];

  return (
    <section
      data-testid="impact-stats-bar"
      className="relative bg-brand-navy text-white py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
          backgroundSize: "40px 40px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-yellow mb-4">
            The urgency is real
          </div>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Inland Empire youth are facing a three-way crisis.
            <span className="text-brand-yellow"> We answer it every afternoon.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {community.map((stat, i) => (
            <motion.div
              key={i}
              data-testid={`impact-stat-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white/[0.04] border border-white/10 rounded-3xl p-8 hover:bg-white/[0.07] transition-colors"
            >
              <div className="font-display font-black text-5xl md:text-6xl text-brand-yellow leading-none">
                {stat.value}
              </div>
              <div className="mt-5 font-semibold text-lg text-white leading-snug">
                {stat.label}
              </div>
              <div className="mt-2 text-sm text-slate-400">{stat.sub}</div>
              <div className="mt-6 pt-6 border-t border-white/10 flex gap-3">
                <span className="w-8 h-8 rounded-full bg-brand-coral flex items-center justify-center flex-shrink-0 font-display font-black text-sm">
                  →
                </span>
                <div className="text-sm text-slate-200 leading-relaxed">
                  {stat.response}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
